// components/section/section.component.jsx

import React, { Children } from "react";
import { GridItem_Section } from "../../styles/base/_base.styles";
import { useCursorChange } from "../../lib/hooks";
import CursorComp from "../cursor/cursor";

const Section = ({ children, cursorsize, nocursor, ...props }) => {
  const [size, setSize, visible, setVisible] = useCursorChange();
  const showCursor = false;

  return (
    <GridItem_Section
      size={props.size}
      style={{ cursor: "auto" }}
      onMouseEnter={setVisible}
      onMouseLeave={setVisible}
      {...props}
    >
      {showCursor && <CursorComp cursorsize={cursorsize} size={size} visible={visible} />}

      {Children.map(children, (child) => {
        // Only try to clone real React elements
        if (!React.isValidElement(child)) return child;

        if (child.props.setsize) {
          return React.cloneElement(child, {
            onMouseEnter: setSize,
            onMouseLeave: setSize,
          });
        }

        if (child.props.setvisible) {
          return React.cloneElement(child, {
            onMouseEnter: setVisible,
            onMouseLeave: setVisible,
          });
        }

        return child;
      })}
    </GridItem_Section>
  );
};

export { Section };
